import React from "react";
import { repeaterToArray } from "./commercialProjectAcf";

/**
 * Shown after permit-plan upload auto-fills materials — drafter must verify before clearing.
 */
export default function PermitMaterialsReviewBanner({ permitRow, onMarkVerified, enabled = true }) {
  if (!enabled || !permitRow?.materials_review_pending) return null;

  const materials = repeaterToArray(permitRow.materials);
  const count = materials.filter((r) => r?.item || r?.slug || r?.quantity).length;

  return (
    <div className="permits-materials-review-banner" role="status">
      <div className="permits-materials-review-banner-head">
        <strong>Verify material totals from permit plan</strong>
      </div>
      <p className="permits-materials-review-banner-text">
        {count > 0
          ? `${count} material line${count === 1 ? "" : "s"} were read from the uploaded plan and filled in below.`
          : "Material totals were read from the uploaded plan."}{" "}
        Please confirm each material name and quantity matches the plan before you continue.
      </p>
      {count > 0 ? (
        <ul className="permits-materials-review-banner-list">
          {materials.slice(0, 6).map((row, i) => (
            <li key={i}>
              {row.item || row.slug || "Material"}
              {row.quantity ? ` — ${row.quantity}` : ""}
            </li>
          ))}
          {materials.length > 6 ? (
            <li className="permits-materials-review-banner-more">+ {materials.length - 6} more below</li>
          ) : null}
        </ul>
      ) : null}
      <button
        type="button"
        className="email-triggers-button email-triggers-button-primary permits-materials-review-verify-btn"
        onClick={onMarkVerified}
      >
        Mark as verified
      </button>
    </div>
  );
}
